import React from 'react';
import { Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { useQuery } from 'react-query';

import { PostTypes } from '../../../Utils/Types';
import { moment } from '../../../I18n';
import { getPostAudits } from '../../../Services/Api';
import AuditsModal from './AuditsModal';
import { filteredAudits } from '../../../Utils/audits';

function AuditsLink({ post }: any) {
  if (post.type !== PostTypes.IDEA) {
    return null;
  }

  const { data } = useQuery(['post-audits', post.id], () => getPostAudits(post.id), {
    enabled: !!window.spaceSlug,
    select: (response: any) => response.data,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });

  const audits = filteredAudits(data?.data) || [];

  if (audits.length === 0) {
    return null;
  }

  return (
    <>
      {' - '}

      <MuiLink
        component={Link}
        to="?audits_modal=true"
        variant="body2"
        underline="hover"
        color="textSecondary"
        sx={{
          fontSize: 14,
          fontWeight: 'regular',
          '&::first-letter': {
            textTransform: 'uppercase',
          },
        }}
      >
        <FormattedMessage
          id="POSTS.AUDITS.UPDATE"
          values={{ date: moment(audits[0].created_at).fromNow() }}
        />
      </MuiLink>
      <AuditsModal audits={audits} />
    </>
  );
}

export default AuditsLink;
